let Values = {
  NERVOUS_TRUNK       : 'NERVOUS_TRUNK',
  INTRA_ARTICULAR     : 'INTRA_ARTICULAR',
  BURSAE_TENDON_SHEATH: 'BURSAE_TENDON_SHEATH'
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value) => {
    switch (value) {

      case Values.NERVOUS_TRUNK:
        return "Nerveuse ou tronculaire";

      case Values.INTRA_ARTICULAR:
        return "Intra-articulaire";

      case Values.BURSAE_TENDON_SHEATH:
        return "Bourses/graines tendineuses";

      default:
        return value;
    }
  },

  /* Get short for value. */
  short: (value) => {
    switch (value) {

      case Values.NERVOUS_TRUNK:
        return "Nerveuse ou tronculaire";

      case Values.INTRA_ARTICULAR:
        return "Intra-articulaire";

      case Values.BURSAE_TENDON_SHEATH:
        return "Bourses/graines tendineuses";

      default:
        return value;
    }
  }
});
